import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {FetchImagesSubTaskProcess, TaskStatusType} from "../types/taskFlow.types";
import CircularProgress from "@mui/material/CircularProgress";
import FilterIcon from '@mui/icons-material/Filter';
import { useDispatch } from 'react-redux';
import {setCurrentDialogImageInfo, setSelectCanvasImage} from '../store/taskSlice';
import { store } from '../store';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';


type IMyEditableShape = TLBaseShape<
    'dialog-tool-bar',
    {
        stepId: string,
        h: number,
        w: number,
    }
>

export class DialogToolBarUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'dialog-tool-bar' as const
    static override props: RecordProps<IMyEditableShape> = {
        stepId: T.string,
        w: T.number,
        h: T.number,
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            stepId: '',
            w: 260,
            h: 80,
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }

    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id


        return (
            <HTMLContainer
                id={shape.id}
                // [b]
                style={{
                    pointerEvents: 'all',
                    display: 'flex',
                    alignItems: 'center',
                }}
                onPointerDown={e => {
                    e.stopPropagation();
                    console.log(e, '对话框位置')
                }}
            >
                <div style={{
                    width: '100%', height: '100%', borderRadius: 10, background: '#007AFF',
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    color: "white",
                }}>
                    <ChatBubbleOutlineIcon style={{fontSize: 50, marginTop: 10}} />
                    <div style={{fontSize: "30px"}}>Chat here</div>
                </div>
            </HTMLContainer>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h} />
    }
}